export enum OnboardingStatus {
  Started = 0,
  InProgress = 1,
  Completed = 2,
  Failed = 3,
  RequiresReview = 4,
}
